import { SpDocument } from '../domain/document';
import { firestore } from 'firebase/app';

export function snapshotToDocument<T extends SpDocument>(doc: firestore.QueryDocumentSnapshot<firestore.DocumentData>): T {
  const creationDateTime: Date =  doc.data().creationDateTime?.toDate() || new Date();
  const document: T = {
    $id: doc.id,
    $path: doc.ref.path,
    ...doc.data(),
    creationDateTime
  } as T;
  return document;
}